import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { UnclaimableReason } from "@redotech/redo-fulfillment-group-common/shipment-summary";
import {
  getMerchantAccountClaimPolicyContext,
  groupClaimBlockedByMerchantAccount,
  groupHasClaimableShipment,
} from "@redotech/redo-package-protection-common/shipping-claims/shipping-claim";
import { getEffectiveShipmentSummary } from "./effective-shipment-summary";

export function getCarrierClaimActionEligibility(
  fulfillmentGroups: readonly FulfillmentGroupData[],
  claimSubmission: Parameters<typeof getMerchantAccountClaimPolicyContext>[0],
): {
  canSubmitCarrierClaim: boolean;
  carrierClaimMerchantAccountBlocked: boolean;
} {
  if (fulfillmentGroups.length !== 1) {
    return {
      canSubmitCarrierClaim: false,
      carrierClaimMerchantAccountBlocked: false,
    };
  }

  const [fulfillmentGroup] = fulfillmentGroups;
  if (!fulfillmentGroup) {
    return {
      canSubmitCarrierClaim: false,
      carrierClaimMerchantAccountBlocked: false,
    };
  }

  const policyContext = getMerchantAccountClaimPolicyContext(claimSubmission);
  const claimActionSummary =
    getEffectiveShipmentSummary(fulfillmentGroup)?.claimActionSummary;
  const canSubmitCarrierClaim =
    !!claimActionSummary?.claimable ||
    groupHasClaimableShipment(fulfillmentGroup, policyContext);
  const summaryBlockedByMerchantAccount =
    claimActionSummary?.claimable === false &&
    claimActionSummary.reason === UnclaimableReason.IS_MERCHANT_ACCOUNT;

  return {
    canSubmitCarrierClaim,
    carrierClaimMerchantAccountBlocked:
      !canSubmitCarrierClaim &&
      (summaryBlockedByMerchantAccount ||
        groupClaimBlockedByMerchantAccount(fulfillmentGroup, policyContext)),
  };
}
